import { doc, setDoc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase/config';
import dayjs from 'dayjs';

export const saveAnswer = async (
  uid: string,
  questionId: string,
  payload: Record<string, unknown>
) => {
  try {
    const answerRef = doc(db, 'questionnaires', uid, 'responses', questionId);
    await setDoc(answerRef, { ...payload, createdAt: serverTimestamp() });
  } catch (err) {
    console.error('saveAnswer failed:', err);
    throw err;
  }
};

export const updateProfileField = async (
  uid: string,
  field: string,
  value: unknown
) => {
  try {
    const userRef = doc(db, 'users', uid); // ← was 'profiles'
    let normalizedValue = value;

    if (typeof value === 'string' && value.match(/^\d{4}-\d{2}-\d{2}T/)) {
      normalizedValue = dayjs(value).format('YYYY-MM-DD');
    }

    await updateDoc(userRef, { [field]: normalizedValue });
  } catch (err) {
    console.error('updateProfileField failed:', err);
    throw err;
  }
};